import { useEffect } from "react";

const CANONICAL_ORIGIN = "https://rcps-terrassement.ch";
const DEFAULT_OG_IMAGE =
    "https://customer-assets.emergentagent.com/job_elated-beaver-5/artifacts/klddihpd_Hero%20header%20-%20Grande.jpeg";

function setMeta(name, content, attr = "name") {
    if (!content) return;
    let el = document.querySelector(`meta[${attr}="${name}"]`);
    if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, name);
        document.head.appendChild(el);
    }
    el.setAttribute("content", content);
}

function setLink(rel, href) {
    if (!href) return;
    let el = document.querySelector(`link[rel="${rel}"]`);
    if (!el) {
        el = document.createElement("link");
        el.setAttribute("rel", rel);
        document.head.appendChild(el);
    }
    el.setAttribute("href", href);
}

/**
 * Seo — Manages document title, meta tags, canonical URL and social cards.
 *
 * By default the canonical URL is derived from the current pathname
 * (using CANONICAL_ORIGIN), so every page automatically gets a canonical
 * pointing to https://www.rcps-terrassement.ch/<path>.
 */
export default function Seo({
    title,
    description,
    canonical,
    image,
    noindex = false,
}) {
    useEffect(() => {
        const brand = "RCPS Terrassement";
        const hasBrand =
            title && title.toLowerCase().includes(brand.toLowerCase());
        const fullTitle = title
            ? hasBrand
                ? title
                : `${title} | ${brand}`
            : "RCPS Terrassement | Terrassement, démolition et génie civil à Genève";
        const desc =
            description ||
            "RCPS Terrassement — Entreprise de terrassement, démolition, génie civil, voirie, enrobés, aménagements extérieurs et enrochage à Genève et en Suisse romande.";

        // Compute a canonical URL from the current pathname if none was provided.
        const pathname =
            typeof window !== "undefined" ? window.location.pathname : "/";
        const canonicalHref =
            canonical || `${CANONICAL_ORIGIN}${pathname === "/" ? "/" : pathname.replace(/\/$/, "")}`;

        const ogImage = image || DEFAULT_OG_IMAGE;

        // Base tags
        document.title = fullTitle;
        setMeta("description", desc);
        setMeta("robots", noindex ? "noindex, nofollow" : "index, follow");

        // Open Graph
        setMeta("og:title", fullTitle, "property");
        setMeta("og:description", desc, "property");
        setMeta("og:type", "website", "property");
        setMeta("og:site_name", brand, "property");
        setMeta("og:url", canonicalHref, "property");
        setMeta("og:image", ogImage, "property");
        setMeta("og:locale", "fr_CH", "property");

        // Twitter
        setMeta("twitter:card", "summary_large_image");
        setMeta("twitter:title", fullTitle);
        setMeta("twitter:description", desc);
        setMeta("twitter:image", ogImage);

        // Canonical
        setLink("canonical", canonicalHref);
    }, [title, description, canonical, image, noindex]);

    return null;
}
